import Vue from 'vue';

const API_URL = process.env.VUE_APP_API_URL;

export default {
  login(payload: any) {
    return Vue.$axios.post(`${API_URL}/login`, {
      ...payload
    })
      .then(resp => {
        return resp.data;
      });
  }
};